/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RetarificationParametreDto } from './RetarificationParametreDto';
import {
    RetarificationParametreDtoFromJSON,
    RetarificationParametreDtoFromJSONTyped,
    RetarificationParametreDtoToJSON,
    RetarificationParametreDtoToJSONTyped,
} from './RetarificationParametreDto';

/**
 * A guarantee of the tunnel in the re-pricing model, with its state on the quote.
 * @export
 * @interface RetarificationGarantieDto
 */
export interface RetarificationGarantieDto {
    /**
     * Tunnel guarantee, null when the tunnel no longer offers it (kept only if selected; read only).
     * 
     * @type {string}
     * @memberof RetarificationGarantieDto
     */
    garantieTunnelId?: string | null;
    /**
     * Referential guarantee.
     * @type {string}
     * @memberof RetarificationGarantieDto
     */
    garantieId: string;
    /**
     * 
     * @type {string}
     * @memberof RetarificationGarantieDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RetarificationGarantieDto
     */
    designation?: string | null;
    /**
     * Mandatory guarantee, cannot be unselected.
     * @type {boolean}
     * @memberof RetarificationGarantieDto
     */
    isRequired: boolean;
    /**
     * The guarantee is on the quote.
     * @type {boolean}
     * @memberof RetarificationGarantieDto
     */
    selectionnee: boolean;
    /**
     * 
     * @type {RetarificationParametreDto}
     * @memberof RetarificationGarantieDto
     */
    plafond?: RetarificationParametreDto | null;
    /**
     * 
     * @type {RetarificationParametreDto}
     * @memberof RetarificationGarantieDto
     */
    franchise?: RetarificationParametreDto | null;
    /**
     * Current premium on the quote, null when not selected.
     * @type {number}
     * @memberof RetarificationGarantieDto
     */
    primeTtc?: number | null;
}

/**
 * Check if a given object implements the RetarificationGarantieDto interface.
 */
export function instanceOfRetarificationGarantieDto(value: object): value is RetarificationGarantieDto {
    if (!('garantieId' in value) || value['garantieId'] === undefined) return false;
    if (!('isRequired' in value) || value['isRequired'] === undefined) return false;
    if (!('selectionnee' in value) || value['selectionnee'] === undefined) return false;
    return true;
}

export function RetarificationGarantieDtoFromJSON(json: any): RetarificationGarantieDto {
    return RetarificationGarantieDtoFromJSONTyped(json, false);
}

export function RetarificationGarantieDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetarificationGarantieDto {
    if (json == null) {
        return json;
    }
    return {
        
        'garantieTunnelId': json['garantieTunnelId'] == null ? undefined : json['garantieTunnelId'],
        'garantieId': json['garantieId'],
        'code': json['code'] == null ? undefined : json['code'],
        'designation': json['designation'] == null ? undefined : json['designation'],
        'isRequired': json['isRequired'],
        'selectionnee': json['selectionnee'],
        'plafond': json['plafond'] == null ? undefined : RetarificationParametreDtoFromJSON(json['plafond']),
        'franchise': json['franchise'] == null ? undefined : RetarificationParametreDtoFromJSON(json['franchise']),
        'primeTtc': json['primeTtc'] == null ? undefined : json['primeTtc'],
    };
}

export function RetarificationGarantieDtoToJSON(json: any): RetarificationGarantieDto {
    return RetarificationGarantieDtoToJSONTyped(json, false);
}

export function RetarificationGarantieDtoToJSONTyped(value?: RetarificationGarantieDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'garantieTunnelId': value['garantieTunnelId'],
        'garantieId': value['garantieId'],
        'code': value['code'],
        'designation': value['designation'],
        'isRequired': value['isRequired'],
        'selectionnee': value['selectionnee'],
        'plafond': RetarificationParametreDtoToJSON(value['plafond']),
        'franchise': RetarificationParametreDtoToJSON(value['franchise']),
        'primeTtc': value['primeTtc'],
    };
}

